import Vue from 'vue'
import 'vant/lib/index.css'
import { Dialog } from 'vant'

Vue.use(Dialog)
